export const generateOptionsArray = (min, max) => {
    const options = [];
    options.push({
        options: Array(max - min + 1)
            .fill('')
            .map((_, index) => ({
            value: `${min + index}`,
            text: `${min + index}`,
        })),
    });
    return options;
};
//# sourceMappingURL=form-fields.utils.js.map